import KeysUpsellDetailModel from './KeysUpsellDetailModel';
import KeysUpsellDetailRenderer from './KeysUpsellDetailRenderer';
const objectType = 'sale';
export default {
  install(molten) {
    molten.addPlugin('Model', {
      type: KeysUpsellDetailModel.TYPE,
      model: KeysUpsellDetailModel
    });
    molten.addPlugin('Detail', {
      name: 'Keys Up-Sell',
      objectType,
      create: () => {
        const json = KeysUpsellDetailModel.create(objectType);
        return json;
      },
      layout: {
        group: []
      }
    });
    molten.addPlugin('DetailRenderer', {
      type: KeysUpsellDetailModel.TYPE,
      renderer: KeysUpsellDetailRenderer
    });
  }
};